import { type Person as PersonCardData, PersonHoverCard } from "@hulahoop/ui";
import type { ReactElement } from "react";
import type { Person, PersonLabels } from "@/domain/types/person";

const toPersonCard = (person: Person, labels: PersonLabels): PersonCardData => ({
  name: person.name,
  role: person.role && labels.roles[person.role],
  organization: person.organization,
  email: person.email,
  phone: person.phone,
  photo: person.photo,
  href: person.href,
});

export function PersonHover({
  person,
  labels,
  children,
}: {
  person: Person;
  labels: PersonLabels;
  children: ReactElement;
}) {
  return (
    <PersonHoverCard
      person={toPersonCard(person, labels)}
      openLabel={labels.open}
      openAriaLabel={labels.openAria}
    >
      {children}
    </PersonHoverCard>
  );
}
